import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryEdit } from 'pages/valueStories/ValueStoryEdit'
import { valueStoriesSearchParams } from 'routes/value-stories/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return (
    <ValueStoryEdit orgId={orgId} siteId={siteId} valueStoryId={undefined} />
  )
}

export const Route = createFileRoute('/value-stories/add')({
  component: RouteComponent,
  staticData: {
    title: 'Add Value Story',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: valueStoriesSearchParams,
})
